// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Layout-module--anchor--vw-vs","layoutContainer":"Layout-module--layoutContainer--3qA13","pageContainer":"Layout-module--pageContainer--1MXgV"};